import React, { useState } from "react";
import { QuestionCollapsableProps } from "../../Utils/Types";
import QuestionAccordionItem from "./QuestionAccordionItem";
import style from "../../Styles/commonWrongQuestions.module.css";

export default function QuestionCollapsable({
  questions,
}: QuestionCollapsableProps) {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panelId: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panelId : false);
    };

  return (
    <div className={style.questionsCollapsable}>
      {questions.map((element: any, index: number) => {
        const question = element?.question;
        return (
          <QuestionAccordionItem
            key={question._id || index}
            question={question}
            panelId={`panel-${index}`}
            expanded={expanded === `panel-${index}`}
            onChange={handleChange(`panel-${index}`)}
          />
        );
      })}
    </div>
  );
}
